import React from "react";
import ColumnRules from "./ColumnRules";



const ImportFinancePlanColumnRules = () => {
  const rules = [
    {
      name: "name",
      required: true,
      options: ["Nome."],
    },
    {
      name: "value",
      required: true,
      options: ["Valor."],
    },
    {
      name: "type",
      required: true,
      options: ["Tipo."],
    },
    {
      name: "validity_start_date",
      required: true,
      options: ["Data de início da vigência."],
    },
    {
      name: "validity_end_date",
      required: true,
      options: ["Data de término da vigência."],
    },
    {
      name: "installments",
      required: true,
      options: ["Parcelas."],
    },
    {
      name: "guarantors",
      required: true,
      options: ["Fiadores."],
    },
    {
      name: "installment_value",
      required: true,
      options: ["Valor da parcela."],
    },
    {
      name: "order",
      required: true,
      options: ["Ordem."],
    },
    {
      name: "update_expired_bill",
      required: true,
      options: ["Permite atualizar boleto vencido."],
    },
    {
      name: "dynamic_first_installment",
      required: true,
      options: ["Primeira parcela dinâmica."],
    },
    {
      name: "first_installment_expiry_days",
      required: true,
      options: ["Dias de validade da primeira parcela."],
    },
  ];

  return <ColumnRules rules={rules} />;
};

export default ImportFinancePlanColumnRules;
